module.exports = __webpack_public_path__ + "static/media/icono-jump.af9a3f44.svg";